import { Outlet } from 'react-router-dom';
import PATH_PAGE from '@/router/path';
import useParamWorkspaceId from '@/hook/useParamWorkspaceId';
import { useMemo, useEffect } from 'react';
import useConsoleLayoutConfig from '@/hook/useConsoleLayoutConfig';
import { useServerlessStore } from '@/store/serverless';
import { useGetServerlessToken } from '@/service/serverless-gpu/hook';
import { useGPUInstanceStore } from '@/store/gpu-instance';

const GPUInstanceLayout = () => {
  const { workspaceId } = useParamWorkspaceId();
  const { setToken } = useGPUInstanceStore();
  const { loading } = useGPUInstanceStore();

  // Reuse serverless token since they share the same authentication
  const { data, isLoading } = useGetServerlessToken(
    {
      workspace_id: workspaceId!,
    },
    {
      retry: (failureCount, error: any) => {
        if (error?.response?.data?.details === 'Not found serverless token') {
          return false;
        }
        return failureCount < 3;
      },
      staleTime: 1000 * 60 * 5,
    }
  );

  useEffect(() => {
    if (!isLoading) {
      setToken(data?.token || null);
    }
  }, [data?.token, isLoading, setToken]);

  const navItems = [
    {
      href: PATH_PAGE.dashboard.gpuInstance.overview(workspaceId),
      label: 'Overview',
      strictMatch: true,
    },
    {
      href: PATH_PAGE.dashboard.gpuInstance.instances(workspaceId),
      label: 'Instances',
      strictMatch: true,
    },
    {
      href: PATH_PAGE.dashboard.gpuInstance.create(workspaceId),
      label: 'Create Instance',
      strictMatch: true,
    },
    {
      href: PATH_PAGE.dashboard.gpuInstance.pricing(workspaceId),
      label: 'Pricing',
      strictMatch: true,
    },
  ];

  const navbarConfig = useMemo(
    () => ({
      title: 'GPU Instance',
      navbar: navItems,
    }),
    [workspaceId]
  );

  useConsoleLayoutConfig({
    navConfig: navbarConfig,
  });

  if (loading) {
    return null;
  }

  return <Outlet />;
};

export default GPUInstanceLayout;
